module.exports = __webpack_public_path__ + "img/result-empty.d51b395e.png";